import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

/**
 * Button — editorial luxury, modern rounded.
 * Radius: pill (rounded-full). Focus ring bordeaux via global :focus-visible.
 * Token-only (no hardcoded hex).
 */
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium tracking-wide transition-colors duration-hover ease-out disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:     "bg-ink text-ivory hover:bg-bordeaux",
        accent:      "bg-bordeaux text-ivory hover:bg-ink",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:     "border border-line bg-transparent text-ink hover:border-ink hover:bg-ink hover:text-ivory",
        secondary:   "bg-secondary text-secondary-foreground hover:bg-secondary/70",
        ghost:       "bg-transparent text-ink hover:bg-secondary",
        link:        "text-ink underline-offset-4 hover:underline hover:text-bordeaux",
      },
      size: {
        sm:      "h-9  px-5 text-xs",
        default: "h-11 px-6 text-sm",
        lg:      "h-12 px-8 text-sm",
        xl:      "h-14 px-10 text-sm",
        icon:    "h-11 w-11",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
})
Button.displayName = "Button"

export { Button, buttonVariants }
